import {
  ChannelkartNetworkGet,
  ChannelkartNetworkPost,
} from "../../../../services/networkService";
import { ServiceHandler } from "../Factory/ServiceFactory";

export class ReplEditingService implements ServiceHandler {
  initialData: any;
  savedRole: any;
  key: string = "";
  domainMapping: Record<string, string[]> = {};
  defaultValues?: any;
  constructor() {
    this.key = "name";
    this.initialData = {};
  }

  async getData(): Promise<any> {
    try {
      return this.defaultValues;
    } catch (error) {
      console.error("Error in fetching the config", error);
      throw new Error("CONFIG_FETCH_FAILED");
    }
  }
  async setDefaultValues(config: any): Promise<any> {
    try {
      const defaultValues = config.reduce((acc: any, item: any) => {
        acc[item?.name] = {
          name: item?.name,
          value: null,
        };
        return acc;
      }, {});

      this.defaultValues = defaultValues;
      return defaultValues;
    } catch (err) {
      console.error("Error is setting default values");
    }
  }
  validateBeforeSave(values: any) {
    const isValid = Object.values(values ?? {}).every((item: any) => {
      const val = item?.value;

      if (val === null || val === undefined) return false;
      if (typeof val === "string" && val.trim() === "") return false;
      if (Array.isArray(val) && val.length === 0) return false;

      return true;
    });

    return {
      isValid,
      errorMessage: isValid
        ? undefined
        : "All configuration fields must be filled before saving",
    };
  }

  async SaveData(values: any): Promise<any> {
    if (!this.validateBeforeSave(values)) {
      throw Error("Input fields are not validated");
    } else {
      const url = "/v1/metaDataFilter/config/arsPercentage";
      try {
        const distributorArray: string[] = values?.distributor?.value ?? [];

        const type: "quantity" | "amount" = values?.type?.value;

        const arsPercentageBound: number = Number(
          values?.arsPercentageBound?.value
        );

        if (!distributorArray.length) {
          throw new Error("Distributor is required");
        }

        const requests = distributorArray.map((distributor) => {
          const requestBody = {
            type,
            distributor,
            arsPercentageBound,
          };

          return ChannelkartNetworkPost(url, requestBody);
        });

        const responses = await Promise.all(requests);

        return responses;
      } catch (err) {
        throw err;
      }
    }
  }

  getDescription(config: string) {}

  getPrifillValue(key: string): any {
    // return this.currentData?.[key]?.value;
  }

  updateState(
    key: string,
    newValue: any,
    values: any,
    extendedAttributes?: any
  ): void {
    const updatedValues = {
      ...values,
      [key]: {
        ...values?.[key],
        value: newValue,
      },
    };
    return updatedValues;
  }
}
